var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElasticSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 96,
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116 49.625a13.05 13.05 0 0 0-8.565-12.294c.217-1.18.325-2.376.323-3.575 0-10.345-8.35-18.74-18.64-18.74-5.98 0-11.582 2.87-15.083 7.8-1.724-1.354-3.825-2.058-6.033-2.058-5.44 0-9.912 4.44-9.912 9.965 0 1.192.216 2.383.592 3.466C53.502 35.977 50 40.96 50 46.484c0 5.58 3.448 10.453 8.62 12.348-.215 1.137-.323 2.33-.323 3.574 0 10.3 8.35 18.685 18.585 18.685 6.033 0 11.582-2.925 15.083-7.8 1.724 1.354 3.88 2.112 6.087 2.112 5.44 0 9.912-4.44 9.912-9.965 0-1.192-.216-2.383-.592-3.466 5.063-1.84 8.62-6.824 8.62-12.348z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.803 43.397l14.706 6.77 14.868-13.107a16.76 16.76 0 0 0 .323-3.304c0-9.207-7.434-16.68-16.592-16.68-5.495 0-10.612 2.708-13.683 7.257l-2.478 12.9 2.855 6.174z",
    fill: "#f4bd19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.558 59.05c-.215 1.083-.323 2.22-.323 3.358 0 9.207 7.488 16.735 16.645 16.735 5.55 0 10.666-2.762 13.8-7.312l2.424-12.9-3.286-6.283-14.76-6.77-14.49 13.16z",
    fill: "#3cbeb1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.45 33.43l10.074 2.383 2.262-11.536c-1.4-1.083-3.07-1.625-4.848-1.625-4.363 0-7.973 3.574-7.973 8.016 0 .92.162 1.896.485 2.762z",
    fill: "#e9478c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.59 35.868c-4.525 1.462-7.65 5.85-7.65 10.615 0 4.658 2.855 8.828 7.165 10.453l14.168-12.9-2.586-5.578-11.097-2.6z",
    fill: "#2c458f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.257 71.776c1.4 1.083 3.07 1.68 4.794 1.68 4.363 0 7.973-3.574 7.973-8.016 0-.975-.162-1.896-.485-2.762l-10.074-2.383-2.21 11.482z",
    fill: "#95c63d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.304 57.64l11.097 2.6c4.525-1.516 7.65-5.85 7.65-10.615 0-4.658-2.855-8.774-7.165-10.453L92.34 51.954l2.963 5.687z",
    fill: "#176655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElasticSearch);
export default __webpack_public_path__ + "static/media/ElasticSearch.9d85a673b727defda2d8eda738478669.svg";
export { ForwardRef as ReactComponent };